var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasicDialog',{attrs:{"max-width":"500px","title":_vm.title,"button-text":_vm.buttontText},on:{"onClose":_vm.onClose,"onSubmit":_vm.confirmDelete}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }